module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/anna-potworowska-pluciennik-38badbfec781db7be8afe1fd36937c12.webp";